/**
 * V2 Mega Menu 动画系统
 * 专业的现代化动画效果
 */

class V2MegaMenuAnimations {
  constructor() {
    this.menus = document.querySelectorAll('.v2-mega-menu-wrapper[data-hover-trigger]');
    this.currentOpenMenu = null; // 跟踪当前打开的菜单
    this.init();
    this.prepareAnimations(); // 新增：预初始化动画
  }

  // 预初始化，确保首次动画能正确播放
  prepareAnimations() {
    this.menus.forEach(menu => {
      const content = menu.querySelector('.v2-enhanced-mega-menu');
      if (content) {
        // 获取计算样式，强制浏览器应用transition
        const computedStyle = window.getComputedStyle(content);
        const transition = computedStyle.transition;
        
        // 强制重排，确保初始状态被浏览器识别
        content.style.clipPath = 'inset(0 0 100% 0)';
        void content.offsetHeight;
        
        console.log('动画系统初始化完成，transition:', transition);
      }
    });
  }

  init() {
    // 存储每个菜单的状态
    this.menuStates = new WeakMap();
    
    this.menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.v2-enhanced-mega-menu');
      let hoverTimeout;
      let closeTimeout;
      
      // 存储菜单状态
      this.menuStates.set(menu, { isOpen: false, isAnimating: false });

      // 鼠标进入主菜单项
      summary.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        clearTimeout(closeTimeout);
        
        const menuState = this.menuStates.get(menu);
        
        if (!menuState.isOpen && !menuState.isAnimating) {
          hoverTimeout = setTimeout(() => {
            // 如果有其他菜单打开，先关闭它
            if (this.currentOpenMenu && this.currentOpenMenu !== menu) {
              const otherMenu = this.currentOpenMenu;
              const otherMenuState = this.menuStates.get(otherMenu);
              
              // 关闭其他菜单
              this.closeMenu(otherMenu, () => {
                otherMenuState.isOpen = false;
                otherMenuState.isAnimating = false;
              });
              otherMenuState.isAnimating = true;
              
              // 等待关闭动画完成后再打开新菜单
              setTimeout(() => {
                this.openMenu(menu, () => {
                  menuState.isOpen = true;
                  menuState.isAnimating = false;
                  this.currentOpenMenu = menu; // 更新当前打开的菜单
                });
                menuState.isAnimating = true;
              }, 350); // 等待关闭动画（300ms）+ 小延迟（50ms）
            } else {
              // 没有其他菜单打开，直接打开
              this.openMenu(menu, () => {
                menuState.isOpen = true;
                menuState.isAnimating = false;
                this.currentOpenMenu = menu; // 更新当前打开的菜单
              });
              menuState.isAnimating = true;
            }
          }, 100); // 100ms 延迟，避免误触
        }
      });

      // 鼠标离开整个菜单区域
      menu.addEventListener('mouseleave', () => {
        clearTimeout(hoverTimeout);
        clearTimeout(closeTimeout);
        
        const menuState = this.menuStates.get(menu);
        
        if (menuState.isOpen && !menuState.isAnimating) {
          closeTimeout = setTimeout(() => {
            this.closeMenu(menu, () => {
              menuState.isOpen = false;
              menuState.isAnimating = false;
              if (this.currentOpenMenu === menu) {
                this.currentOpenMenu = null; // 清除当前打开的菜单引用
              }
            });
            menuState.isAnimating = true;
          }, 150); // 150ms 延迟，提供更好的用户体验
        }
      });

      // 鼠标进入内容区域时保持打开
      if (content) {
        content.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout);
          clearTimeout(closeTimeout);
        });
      }

      // 点击切换
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const menuState = this.menuStates.get(menu);
        
        if (!menuState.isAnimating) {
          if (menuState.isOpen) {
            this.closeMenu(menu, () => {
              menuState.isOpen = false;
              menuState.isAnimating = false;
              if (this.currentOpenMenu === menu) {
                this.currentOpenMenu = null;
              }
            });
          } else {
            // 先关闭其他菜单
            if (this.currentOpenMenu && this.currentOpenMenu !== menu) {
              const otherMenu = this.currentOpenMenu;
              const otherMenuState = this.menuStates.get(otherMenu);
              
              this.closeMenu(otherMenu, () => {
                otherMenuState.isOpen = false;
                otherMenuState.isAnimating = false;
              });
              otherMenuState.isAnimating = true;
            }
            
            this.openMenu(menu, () => {
              menuState.isOpen = true;
              menuState.isAnimating = false;
              this.currentOpenMenu = menu;
            });
          }
          menuState.isAnimating = true;
        }
      });
    });
  }

  openMenu(menu, callback) {
    const details = menu;
    const content = menu.querySelector('.v2-enhanced-mega-menu');
    const inner = content.querySelector('.v2-mega-menu__inner');
    
    console.log('开始打开菜单'); // 调试日志
    
    // 移除关闭类
    content.classList.remove('v2-menu-closing');
    
    // 重置内容状态
    inner.classList.remove('v2-content-visible');
    this.resetAnimations(content);
    
    // 确保从顶部开始（解决首次动画和位置问题）
    content.style.clipPath = 'inset(0 0 100% 0)';
    content.style.visibility = 'hidden';
    
    // 强制重排，确保 transition 从初始状态开始
    void content.offsetHeight;
    
    // 重置内联样式，让CSS类接管
    content.style.clipPath = '';
    content.style.visibility = '';
    
    // 打开 details 元素，触发 transition
    details.setAttribute('open', '');
    
    console.log('背景下拉动画开始（CSS transition）'); // 调试日志
    
    // 等待背景下拉动画完成后显示内容
    setTimeout(() => {
      console.log('显示内容'); // 调试日志
      inner.classList.add('v2-content-visible');
      
      // 内容显示后开始内部元素动画
      setTimeout(() => {
        console.log('内部元素动画开始'); // 调试日志
        this.animateMenuParts(content);
        if (callback) callback(); // 动画完成回调
      }, 100);
    }, 300); // 0.3秒后（背景动画完成）
  }

  closeMenu(menu, callback) {
    const details = menu;
    const content = menu.querySelector('.v2-enhanced-mega-menu');
    const inner = content.querySelector('.v2-mega-menu__inner');
    
    console.log('开始关闭菜单'); // 调试日志
    
    // 不隐藏内容，让它随着抽屉一起收起
    this.resetAnimations(content);
    
    // 强制重排，确保 transition 可以正常触发
    void content.offsetHeight;
    
    // 添加关闭类，触发收起 transition
    content.classList.add('v2-menu-closing');
    
    console.log('背景上拉动画开始（CSS transition 收起）'); // 调试日志
    
    // 动画结束后关闭菜单
    setTimeout(() => {
      // 关闭菜单
      details.removeAttribute('open');
      // 清理所有类
      content.classList.remove('v2-menu-closing');
      inner.classList.remove('v2-content-visible');
      
      // 重置所有内部动画，确保下次打开时不会闪现
      this.resetAnimations(content);
      
      console.log('菜单关闭完成'); // 调试日志
      
      if (callback) callback(); // 动画完成回调
    }, 300); // 0.3秒后（收起动画完成）
  }

  animateMenuParts(content) {
    // 左侧分类 - 错开动画（立即开始）
    const categories = content.querySelectorAll('.v2-mega-menu__category-item');
    categories.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('v2-animate-slide-right');
      }, index * 100); // 更快的间隔
    });

    // 中间产品卡 - 错开动画（稍微延迟）
    const products = content.querySelectorAll('.v2-mega-menu__product-item');
    products.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('v2-animate-slide-up');
      }, 100 + (index * 160)); // 延迟100ms开始
    });

    // 右侧推荐区 - 淡入（最后）
    const featured = content.querySelector('.v2-mega-menu__featured');
    if (featured) {
      setTimeout(() => {
        featured.classList.add('v2-animate-fade-in');
      }, 200); // 延迟200ms
    }
  }

  resetAnimations(content) {
    // 移除所有内部元素的动画类
    const categories = content.querySelectorAll('.v2-mega-menu__category-item');
    categories.forEach(item => {
      item.classList.remove('v2-animate-slide-right');
    });

    const products = content.querySelectorAll('.v2-mega-menu__product-item');
    products.forEach(item => {
      item.classList.remove('v2-animate-slide-up');
    });

    const featured = content.querySelector('.v2-mega-menu__featured');
    if (featured) {
      featured.classList.remove('v2-animate-fade-in');
    }
  }

}

// 初始化动画系统
document.addEventListener('DOMContentLoaded', () => {
  new V2MegaMenuAnimations();
});